module.exports = __webpack_public_path__ + "img/xsyficon03.png";